export const cnpjFormInitialValues = {
  isAllFieldsVisible: false,
  cnpj: '',
  tradingName: '',
  zipCode: '',
  street: '',
  number: '',
  neighborhood: '',
  state: '',
  city: '',
  complement: '',
  revenue: '',
  terms: false,
};
